import React from 'react'
import { any, async, fromJSX, Widget } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'
import { paginationWidget } from '../pagination/paginationWidget'
import { NewsOverviewLayout } from './newsOverviewLayout'
import { NewsOverviewState, newsOverviewStateUpdaters } from './newsOverviewState'

export const newsOverviewWidget =
  (page: number, department?: string, subDepartment?: string, specialist?: string, centrum?: string, tags?: string[]) =>
  (state: NewsOverviewState): Widget<Updater<NewsOverviewState>> =>
    any<Updater<NewsOverviewState>>([
      async<NewsOrEvent[]>(state.newsItemsState, items =>
        fromJSX(() => (
          <NewsOverviewLayout
            index={355234}
            items={items}
            breadcrumbs={[
              { title: 'Spaarne Gasthuis', url: '/' },
              { title: 'Nieuws', url: '/nieuws' },
            ]}
          />
        ))
      ).map(newsOverviewStateUpdaters.updateNewsItemsState),
      paginationWidget(
        page,
        12,
        (newPage: number) =>
          `/nieuws?${(department ? [`department=${department}`] : [])
            .concat(subDepartment ? [`subdepartment=${subDepartment}`] : [])
            .concat(specialist ? [`specialist=${specialist}`] : [])
            .concat(centrum ? [`centrum=${centrum}`] : [])
            .concat(tags ? tags.map((tag) => `tags=${tag}`) : [])
            .join('&')}&page=${newPage}`
      )(state.paginationState).map(newsOverviewStateUpdaters.updateNewsCountState),
    ])
